module.exports = __webpack_public_path__ + "img/9788960171459.b163385a.jpg";